// import 'bootstrap/dist/css/bootstrap.css';
// import 'bootstrap/dist/js/bootstrap.bundle';
// import '../assets/css/style.css';
// import '../assets/js/main';
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { List, X, ChevronDown } from "react-bootstrap-icons";

function Header() {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const header = document.querySelector("#header");

    if (header) {
      const headerScrolled = () => {
        header.classList.toggle("header-scrolled", window.scrollY > 100);
      };

      window.addEventListener("load", headerScrolled);
      document.addEventListener("scroll", headerScrolled);

      return () => {
        window.removeEventListener("load", headerScrolled);
        document.removeEventListener("scroll", headerScrolled);
      };
    }

    return undefined;
  }, []);

  useEffect(() => {
    const backtotop = document.querySelector(".back-to-top");
    if (backtotop) {
      const toggleBacktotop = () => {
        if (window.scrollY > 100) {
          backtotop.classList.add("active");
        } else {
          backtotop.classList.remove("active");
        }
      };

      window.addEventListener("load", toggleBacktotop);
      document.addEventListener("scroll", toggleBacktotop);

      return () => {
        window.removeEventListener("load", toggleBacktotop);
        document.removeEventListener("scroll", toggleBacktotop);
      };
    }

    return undefined;
  }, []);

  useEffect(() => {
    const navbar = document.querySelector("#navbar");
    if (navbar) {
      navbar.classList.toggle("navbar-mobile", isMenuOpen);
    }
  }, [isMenuOpen]);

  useEffect(() => {
    const closeMenuOnDesktop = () => {
      if (window.innerWidth >= 992) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener("resize", closeMenuOnDesktop);

    return () => {
      window.removeEventListener("resize", closeMenuOnDesktop);
    };
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleDropdownClick = (event) => {
    const navbar = document.querySelector("#navbar");

    if (navbar?.classList.contains("navbar-mobile")) {
      event.preventDefault();
      event.currentTarget.nextElementSibling?.classList.toggle("dropdown-active");
    }
  };

  const currentPath = location.pathname;
  const currentHash = location.hash;
  const isHomePage = currentPath === "/";
  const isServicesPage = ["/international", "/consults", "/investment", "/communication"].includes(currentPath);
  const isActiveSection = (hash) => isHomePage && currentHash === hash;

  return (
    <>
      <header id="header" className="fixed-top d-flex align-items-cente">
        <div className="container-fluid container-xl d-flex align-items-center justify-content-lg-between">
          {/* <!--h1 className="logo me-auto me-lg-0"><a href="index.html">2020 Group LLC</a></h1--> */}
          {/* <!-- Uncomment below if you prefer to use an image logo --> */}
          <Link to="/" className="logo me-auto me-lg-0" onClick={closeMenu}>
            <img
              src={require("../assets/img/2020group_logo_white.png")}
              alt=""
              className="img-fluid"
            />
          </Link>

          <nav id="navbar" className="navbar order-last order-lg-0">
            <ul>
              <li>
                <HashLink
                  className={`nav-link scrollto${isActiveSection("#hero") ? " active" : ""}`}
                  to="/#hero"
                  onClick={closeMenu}
                >
                  Home
                </HashLink>
              </li>
              <li>
                <HashLink
                  className={`nav-link scrollto${isActiveSection("#about") ? " active" : ""}`}
                  to="/#about"
                  onClick={closeMenu}
                >
                  What We Do
                </HashLink>
              </li>
              <li>
                <HashLink
                  className={`nav-link scrollto${isActiveSection("#why-us") ? " active" : ""}`}
                  to="/#why-us"
                  onClick={closeMenu}
                >
                  Why Us
                </HashLink>
              </li>
              <li>
                <HashLink
                  className={`nav-link scrollto${isActiveSection("#overview") ? " active" : ""}`}
                  to="/#overview"
                  onClick={closeMenu}
                >
                  Overview
                </HashLink>
              </li>
              <li>
                <HashLink
                  className={`nav-link scrollto${isActiveSection("#services") ? " active" : ""}`}
                  to="/#services"
                  onClick={closeMenu}
                >
                  Our Services
                </HashLink>
              </li>
              <li className={`dropdown${isServicesPage ? " active" : ""}`} id="dropdown">
                <Link to="#" onClick={handleDropdownClick}>
                  <span>Services</span>{" "}
                  <i className="bi bi-chevron-down">
                    <ChevronDown />
                  </i>
                </Link>
                <ul>
                  <li>
                    <Link to="/international" onClick={closeMenu}>
                      International
                    </Link>
                  </li>
                  <li>
                    <Link to="/consults" onClick={closeMenu}>
                      Consults
                    </Link>
                  </li>
                  <li>
                    <Link to="/investment" onClick={closeMenu}>
                      Investment
                    </Link>
                  </li>
                  <li>
                    <Link to="/communication" onClick={closeMenu}>
                      Communication
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <HashLink
                  className={`nav-link scrollto${isActiveSection("#contact") ? " active" : ""}`}
                  to="/#contact"
                  onClick={closeMenu}
                >
                  Contact
                </HashLink>
              </li>
            </ul>
            <i className="bi bi-list mobile-nav-toggle" onClick={toggleMenu}>
              {isMenuOpen ? (
                <X className="mobile-nav-toggle" size={30} id="navbar-toggle" />
              ) : (
                <List className="mobile-nav-toggle" size={30} id="navbar-toggle" />
              )}
            </i>
          </nav>
          <HashLink
            to="/#contact"
            className={`book-a-table-btn scrollto d-none d-lg-flex${isActiveSection("#contact") ? " active" : ""}`}
            onClick={closeMenu}
          >
            Request a Call
          </HashLink>
        </div>
      </header>
    </>
  );
}

export default Header;
